// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"140":"f4cb4d6b","664":"8fe23e7f","759":"a3db7fc9","803":"b0998ab3","820":"68d129a3"}[chunkId] + ".js";
};